import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import StepItemContext from './StepItemContext.esm.js';

const StepItemMain = ({ addClassName = "", children, }) => {
    return (React.createElement("div", { className: classNames("tw-flex tw-flex-col tw-h-full tw-w-full", addClassName) }, children));
};
const StepItem = (props) => {
    const { index, last = false, status = "inactive", disabled, children, } = props;
    const active = status === "current";
    const complete = status === "complete";
    const inactive = status === "inactive";
    const error = status === "error";
    const context = React.useMemo(() => ({
        index,
        last,
        stepNumber: index + 1,
        active,
        complete,
        inactive,
        error,
        status,
        disabled,
    }), [index, last, active, complete, inactive, status, disabled, error]);
    return (React.createElement(StepItemContext.Provider, { value: context },
        React.createElement(StepItemMain, { ...props }, children)));
};

export { StepItem };
//# sourceMappingURL=StepItem.esm.js.map
